import { render } from "./Index.vue?vue&type=template&id=221bec78&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=221bec78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221bec78"]])

export default __exports__